import React, { FC, ReactNode } from 'react';
import cls from './TablePagination.module.scss';
import { Meta, MetaPost } from 'src/models/types';
import { SearchQueryParams } from 'src/hooks/useSearchQueryParams';
import { useTranslation } from 'react-i18next';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import selectors from 'src/redux/selectors';
import ActionBlock from './ActionBlock';

export type PaginationProps = {
  meta?: Meta | MetaPost;
  setParams: (params: any) => void;
  params: SearchQueryParams;
  className?: string;
  hasInfo?: boolean;
  text?: ReactNode;
  customPerPageList?: number[];
};
export const perPageList = [25, 50, 100, 200, 400];
const Pagination: FC<PaginationProps> = ({
  meta,
  setParams,
  params,
  className,
  hasInfo = true,
  text,
  customPerPageList,
}) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'pagination',
  });

  const selectedRows = useTypedSelector(selectors.getSelectedRows);
  if (!meta) {
    return null;
  } else {
    return (
      <div
        className={`${cls['wrapper']} table-pagination${
          className ? ` ${className}` : ''
        }`}
      >
        {hasInfo && (
          <div className={cls['info-block']}>
            <span>
              {t('entries-from-to', {
                from: meta.from,
                to: meta.to,
                total: meta.total,
              })}
            </span>
            {!!selectedRows.length && (
              <span>
                {t('selected')}: {selectedRows.length}
              </span>
            )}
            {!!text && <span>{text}</span>}
          </div>
        )}
        <ActionBlock
          params={params}
          setParams={setParams}
          meta={meta}
          customPerPageList={customPerPageList}
        />
      </div>
    );
  }
};
export default Pagination;
